import { api } from 'common';

import { DocumentTemplateBlockFormFields } from './FormFields';
import { DocumentTemplateBlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

import GenerateDocumentMode = api.FlowDefinition.GenerateDocumentMode;

export const DocumentTemplateConfig: BlockConfigProps<api.FlowDefinition.DocumentTemplateBlockConfig> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'generateDocument',
    defaultConfig: {
      documentTemplateId: '',
      valuesByDocumentTemplateKey: {},
      generateDocumentMode: GenerateDocumentMode.DocumentTemplate,
      returnType: api.FlowDefinition.ProducedType.FileReference,
    },
    configFields: {
      schema: api.FlowDefinition.DocumentTemplateBlockConfigSchema,
      FormFields: DocumentTemplateBlockFormFields,
    },
    documentationMarkdown: DocumentTemplateBlockDocumentationMarkdown,
  };
